module.exports = __webpack_public_path__ + "static/media/track-your-business-icon.aa8e79d6.svg";